import gql from 'graphql-tag';

export default gql`
  fragment ReverbHeaderUserMenuData on rql_Me {
    shop {
      _id
      slug
      paymentMethod
    }
    reverbCredits {
      display
      currency
    }
    payoutBalances {
      display
      currency
    }
  }
`;
